import React, { ReactNode } from "react";
import { Row, Col, Dropdown } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Text from "antd/lib/typography/Text";
import { Divider } from "../Divider/Divider";

type SectionHeaderProps = {
  text: string;
  subtext?: string;
  dropdown?: React.ReactElement;
  buttons?: React.ReactElement;
};

export class SectionHeader extends React.Component<SectionHeaderProps> {
  render() {
    const { text, subtext, dropdown, buttons } = this.props;
    return (
      <div>
        <Row>
          <Col span={24}>
            <Row>
              <Col span={24}>
                <h4 className="font-bold my-0 text-lg">{text}</h4>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col span={18}>
                <Text className="text-xs font-medium">{subtext}</Text>
              </Col>
              {buttons && (
                <Col>
                  {buttons}
                </Col>
              )}
              {dropdown && (
                <Col>
                  <Dropdown
                    placement="bottomRight"
                    overlay={dropdown}
                    trigger={["click"]}
                    overlayStyle={{ minWidth: 128 }}
                  >
                    <MenuOutlined style={{ fontSize: "18px" }} />
                  </Dropdown>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Divider />
          </Col>
        </Row>
      </div>
    );
  }
}
